import {
    SupportCaseState,
    useSupportCaseStore,
} from '../../../store/supportCaseStore';
import RootQuestion from '../../organs/zogefixt/RootQuestion';
import Question from '../../organs/zogefixt/Question';
import Solutions from '../../organs/zogefixt/Solutions';
import {ItemsSelector} from '../../organs/zogefixt/ItemsSelector';
import Elaborate from '../../organs/zogefixt/Elaborate';
import {BobAvatar, Heading} from '@toppy-webshop/toppy-design-system';

interface QuestionaireProps {
    cardsLayout?: boolean;
    customerName?: string;
}

const Questionaire = ({
    cardsLayout = true,
    customerName,
}: QuestionaireProps) => {
    const state = useSupportCaseStore(state => state.state);
    const stateItems = useSupportCaseStore(state => state.stateItems);
    let skipNextStates = false;

    let questionOrderNumber = 0;

    return (
        <div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginBottom: '1rem',
                }}
            >
                <BobAvatar size={'large'} />
                <div
                    style={{
                        flexGrow: 1,
                        paddingLeft: '1rem',
                    }}
                >
                    <Heading type={'h4'}>
                        Hey{customerName ? ` ${customerName}` : ''},
                        <br />
                        We gaan je helpen!
                    </Heading>
                </div>
            </div>
            {[
                ...state
                    .map((state: SupportCaseState, index) => {
                        if (skipNextStates) {
                            return null;
                        }

                        questionOrderNumber++;

                        if (state.type === 'rootQuestions') {
                            return (
                                <RootQuestion
                                    questions={state.questions}
                                    state={state}
                                    cardsLayout={cardsLayout}
                                    key={`state_${index}`}
                                    questionOrderNumber={questionOrderNumber}
                                />
                            );
                        }
                        if (
                            state.type === 'question' ||
                            state.type === 'multiItemQuestion'
                        ) {
                            return (
                                <Question
                                    state={state}
                                    stateIndex={index}
                                    cardsLayout={cardsLayout}
                                    key={`state_${index}`}
                                    questionOrderNumber={questionOrderNumber}
                                />
                            );
                        }
                        if (state.type === 'itemsSelection') {
                            if (stateItems.length === 0) {
                                skipNextStates = true;
                            }

                            return (
                                <ItemsSelector
                                    state={state}
                                    stateIndex={index}
                                    cardsLayout={cardsLayout}
                                    key={`state_${index}`}
                                    questionOrderNumber={questionOrderNumber}
                                />
                            );
                        }
                        if (
                            state.type === 'solution' ||
                            (state.type === 'solutionPerItem' &&
                                Object.keys(state.solutions).length ===
                                    stateItems.length)
                        ) {
                            return (
                                <Solutions
                                    solutions={state.solutions}
                                    state={state}
                                    cardsLayout={cardsLayout}
                                    key={`state_${index}`}
                                    questionOrderNumber={questionOrderNumber}
                                />
                            );
                        }
                        if (state.type === 'elaborate') {
                            return (
                                <Elaborate
                                    state={state}
                                    cardsLayout={cardsLayout}
                                    key={`state_${index}`}
                                    questionOrderNumber={questionOrderNumber}
                                />
                            );
                        }

                        return null;
                    })
                    .filter(item => item !== null),
            ]}
        </div>
    );
};

export default Questionaire;
